import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { FREE, STARTER } from 'self-service-api/constants/ProductLevels';
import { HighlightedProductsHeaderConfig } from '../../../constants/merchCards/HighlightedProductsHeaderConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const BusinessObjectivesLowerTierMessage = ({
  productLine,
  productLevel,
  handleClick
}) => {
  const config = HighlightedProductsHeaderConfig[productLine][productLevel];
  const lowerTierPlus = config.lowerTierPlus || '';
  return productLevel === FREE ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "merchCards.businessObjectives.includes"
  }) : productLevel === STARTER ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "merchCards.businessObjectives.freeToolsPlus",
    options: {
      freeToolsWithIncreasedLimits: /*#__PURE__*/_jsx(UILink, {
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.businessObjectives.freeToolsWithLimits"
        })
      })
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: lowerTierPlus
  });
};
export default BusinessObjectivesLowerTierMessage;